<template>
  <Teleport to="body">
    <Transition name="confirm-fade">
      <div
        v-if="confirmDialogState.visible"
        class="fixed inset-0 z-[70] flex items-center justify-center bg-black/40"
        role="alertdialog"
        aria-modal="true"
        @click.self="handleCancel"
      >
        <div class="bg-card rounded-xl border border-border shadow-lg p-6 max-w-sm mx-4">
          <p class="text-foreground mb-4">{{ confirmDialogState.message }}</p>
          <div class="flex gap-2 justify-end">
            <button
              class="border border-border text-muted-foreground hover:bg-secondary/50 px-4 py-1.5 rounded text-sm font-medium"
              @click="handleCancel"
            >
              {{ confirmDialogState.cancelLabel || t('common.cancel') }}
            </button>
            <button
              ref="confirmBtn"
              :class="
                confirmDialogState.variant === 'destructive'
                  ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
                  : 'bg-primary text-primary-foreground hover:bg-primary/90'
              "
              class="px-4 py-1.5 rounded text-sm font-medium"
              @click="handleConfirm"
            >
              {{
                confirmDialogState.confirmLabel ||
                (confirmDialogState.variant === 'destructive'
                  ? t('common.delete')
                  : t('common.confirm'))
              }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, watch, nextTick, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { confirmDialogState, handleConfirm, handleCancel } from '../composables/useConfirmDialog'

const { t } = useI18n()
const confirmBtn = ref(null)

function onKeydown(e) {
  if (e.key === 'Escape') handleCancel()
}

watch(
  () => confirmDialogState.visible,
  async (val) => {
    if (val) {
      document.addEventListener('keydown', onKeydown)
      await nextTick()
      confirmBtn.value?.focus()
    } else {
      document.removeEventListener('keydown', onKeydown)
    }
  },
)

onUnmounted(() => {
  document.removeEventListener('keydown', onKeydown)
})
</script>

<style scoped>
.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.15s ease;
}
.confirm-fade-enter-from,
.confirm-fade-leave-to {
  opacity: 0;
}
</style>
